import styled from "styled-components";
import theme from "../../../../styles/theme";

export const HorizontalCardStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  padding: 1rem;
  border-radius: 15px;
  box-shadow: 3px 4px 6px 3px rgba(0, 0, 0, 0.1);

  /* Ajuste: Define o mínimo, mas permite crescer horizontalmente */
  min-width: 15vw;
  width: auto;

  /* Ajuste: Define altura mínima, mas permite crescer verticalmente se o conteúdo quebrar linha */
  min-height: 10vh;
  height: auto;

  color: #5f6368;
  justify-content: space-between;

  @media (${theme.devices.tablet}) {
    /* Ajuste: Troca width fixo por min-width também no tablet */
    min-width: 38vw;
    width: 85%;
    height: auto;
    flex-direction: column;
  }
  @media (${theme.devices.laptop}) {
    min-height: 15vh;
  }

  .left-container {
    display: flex;
  }

  .right-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 1vw;
    .trend-value {
      font-family: "Roboto", sans-serif;
      font-size: ${theme.fontSize.mm};
    }
  }

  .icon-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 1vh;

    .icon {
      width: 50px;
      @media (${theme.devices.tablet}) {
        width: 40px;
      }
    }

    .label {
      font-family: ${theme.fonts.gilroyRegular};
      font-size: ${theme.fontSize.mm};
      text-align: center;
      width: 100%;
      @media (${theme.devices.tablet}) {
        font-size: ${theme.fontSize.mm};
      }
    }
  }

  .value {
    font-family: ${theme.fonts.gilroySemiBold};
    font-size: ${theme.fontSize.xlg};
    margin-left: auto;
    @media (${theme.devices.tablet}) {
      font-size: ${theme.fontSize.lg};
      margin-left: 0px;
      margin-right: 0px;
    }
    @media (${theme.devices.laptop}) {
      font-size: 35px;
    }
  }
`;
